export default "__VITE_ASSET__BYesWtBD__"